import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "person",
  relative: ""
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = {
  key: 1,
  class: "initials"
}
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = { class: "name ellipsis" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "actions",
  clickable: ""
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "position" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "company" }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_el_image = _resolveComponent("el-image")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_SaveDoc = _resolveComponent("SaveDoc")
  const _component_MdContent = _resolveComponent("MdContent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" IMAGE "),
      _createVNode(_component_el_image, {
        class: "avatar",
        fit: "contain",
        src: $options.image_url
      }, {
        error: _withCtx(() => [
          ($props.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                shape: "circle",
                width: "10rem",
                height: "10rem"
              }))
            : ($options.initials)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($options.initials), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
        ]),
        placeholder: _withCtx(() => [
          ($props.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                shape: "circle",
                width: "10rem",
                height: "10rem"
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["src"]),
      _createCommentVNode(" INFO "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createCommentVNode(" NAME "),
          _createElementVNode("div", _hoisted_6, [
            ($options.name)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: $options.name
                }, null, 8 /* PROPS */, _hoisted_7))
              : (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "3.6rem"
                }))
          ]),
          _createCommentVNode(" ACTIONS "),
          _createElementVNode("div", _hoisted_8, [
            ($options.email)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  text: "Send email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      class: "action-icon pointer",
                      icon: "mail-02",
                      "stroke-width": "1",
                      stroke: "var(--gray-900)",
                      width: "2rem",
                      height: "2rem",
                      disabled: $props.loading,
                      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.sendMail()), ["stop"]))
                    }, null, 8 /* PROPS */, ["disabled"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_Tooltip, { text: "View Linkedin" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "action-icon pointer",
                  disabled: $props.loading || !$options.linkedin_url,
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.openLinkedin()), ["stop"]))
                }, [
                  _createVNode(_component_Icon, {
                    icon: "social/linkedin-circle",
                    width: "2rem",
                    height: "2rem"
                  })
                ], 8 /* PROPS */, _hoisted_9)
              ]),
              _: 1 /* STABLE */
            }),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_SaveDoc, {
                  key: 1,
                  disabled: $props.loading,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  onSave: _cache[3] || (_cache[3] = $event => (_ctx.$emit('save', $event)))
                }, null, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" POSITION "),
        _createElementVNode("div", _hoisted_10, [
          ($options.position)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "ellipsis",
                innerHTML: $options.position
              }, null, 8 /* PROPS */, _hoisted_11))
            : ($props.loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "1.8rem"
                }))
              : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" COMPANY "),
        _createElementVNode("div", _hoisted_12, [
          ($options.company)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "ellipsis",
                innerHTML: $options.company
              }, null, 8 /* PROPS */, _hoisted_13))
            : ($props.loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "1.8rem"
                }))
              : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" BIO "),
    ($options.bio)
      ? (_openBlock(), _createBlock(_component_MdContent, {
          key: 0,
          markdown: $options.bio,
          class: "bio"
        }, null, 8 /* PROPS */, ["markdown"]))
      : ($props.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 1,
            class: "bio",
            width: "100%",
            height: "2.4rem"
          }))
        : _createCommentVNode("v-if", true)
  ]))
}